import { request } from "../network/request";

/**
 * 查询项目成本核算
 * @returns
 * bmbh string 部门编号
 * areaDirector string  区域总监
 * xmbh string 项目编号
 * qssj string 起始时间
 * jssj string 结束时间
 * page integer 页码
 * pageSize integer 分页大小
 */
export function getXmcbhsList(params) {
  const { bmbh, qsrq, jsrq, page, pageSize, htlx } = params;
  const qyzj = params.areaDirector.join(",");
  const xmbh = params.xmbh.join(",");
  return request({
    url: "pmp/cbhs/xmcbhsList",
    method: "post",
    params: {
      bmbh,
      areaDirector: qyzj,
      xmbh,
      qsrq,
      jsrq,
      page,
      pageSize,
      htlx,
    },
  });
}
/**
 * 查询项目成本预算
 * @param {*} xmbh 项目编号
 * @param {*} ysqsrq 预算起始时间
 * @param {*} ysjsrq 预算结束时间
 * @returns
 */
export function getCbhs(params) {
  return request({
    url: "pmp/cbhs/getCbhs",
    method: "post",
    params,
  });
}
/**
 * 保存项目成本预算
 * @param {*} params
 * @returns
 */
export function saveCbhs(params) {
  return request({
    url: "pmp/cbhs/addCbhs",
    method: "post",
    params,
  });
}
/**
 * 判断是否是项目总监
 * @returns
 */
export function isAreaDirector() {
  return request({
    url: "pmp/cbhs/isAreaDirector",
    method: "get",
  });
}
/**
 * 获取部门列表
 * @returns
 */
export function getBmxx() {
  return request({
    url: "pmp/cbhs/getBmxx",
    method: "get",
  });
}
/**
 * 获取项目总监列表
 * @returns
 */
export function getAreaDirector(bmbh) {
  return request({
    url: "pmp/cbhs/getAreaDirector",
    method: "get",
    params: { bmbh },
  });
}

/**
 * 获取项目总监列表
 * @returns
 */
export function getZxzj(bmbh) {
  return request({
    url: "pmp/cbhs/getZxzj",
    method: "get",
    params: { bmbh },
  });
}

/**
 * 获取项目信息
 * @param {*} bmbh  部门编号
 * @param {*} areaDirector 区域总监
 * @param {*} xmjd 项目节点
 * @returns
 */
export function getXmxx(bmbh, areaDirector, xmjd) {
  return request({
    url: "pmp/cbhs/getXmxx",
    method: "get",
    params: { bmbh, areaDirector, xmjd },
  });
}

/**
 * 项目成本核算明细
 * @param {*} params
 * @param {*} bmbh
 * @param {*} xmbh
 * @param {*} qsrq
 * @param {*} jsrq
 * @returns
 */
export function getXmcbhsDetail(params) {
  return request({
    url: "pmp/cbhs/xmcbhsDetail",
    method: "post",
    params,
  });
}

/**
 * 项目成本核算导出
 * @returns
 * bmbh string 部门编号
 * areaDirector string  区域总监
 * xmbh string 项目编号
 * qssj string 起始时间
 * jssj string 结束时间
 */
export function xmcbhsExport(params) {
  return request({
    url: "pmp/cbhs/xmcbhsExport",
    method: "post",
    params,
  });
}

/**
 * 项目成本核算明细导出
 * @param {*} params
 * @returns
 */
export function detailExport(params) {
  return request({
    url: "pmp/cbhs/detailExport",
    method: "post",
    params,
  });
}
/**
 *项目成本核算 合同类型
 * @param {*} params
 * @returns
 */
export function getHtlx(params) {
  return request({
    url: "pmp/cbhs/getHtlx",
    method: "get",
    params,
  });
}
/**
 * 项目成本核算 回款明细
 * @param {*} params
 * @returns
 */
export function getHkList(params) {
  return request({
    url: "pmp/cbhs/getHkList",
    method: "post",
    params,
  });
}
/**
 * 回款明细导出
 * @param {*} params
 * @returns
 */
export function hkListExport(params) {
  return request({
    url: "pmp/cbhs/hkListExport",
    method: "post",
    params,
  });
}
